import { Injectable } from '@angular/core';
import { createClient, SupabaseClient } from '@supabase/supabase-js';
import { environment } from '../../../environments/environment';

/** The one place the app connects to Supabase. `ng serve` points at dev, `ng build` at prod. */
@Injectable({ providedIn: 'root' })
export class SupabaseService {
  readonly db: SupabaseClient = createClient(environment.supabaseUrl, environment.supabaseKey);
  readonly environmentName = environment.name;
}
